import { useEffect, useState } from 'react';

// Cycles through `words`, typing and deleting each one for a typewriter effect.
const useTypewriter = (words, { typeSpeed = 90, deleteSpeed = 45, pause = 1400 } = {}) => {
    const [index, setIndex] = useState(0);
    const [subIndex, setSubIndex] = useState(0);
    const [deleting, setDeleting] = useState(false);

    useEffect(() => {
        if (!words.length) return;
        const current = words[index % words.length];

        if (!deleting && subIndex === current.length) {
            const timer = setTimeout(() => setDeleting(true), pause);
            return () => clearTimeout(timer);
        }

        if (deleting && subIndex === 0) {
            setDeleting(false);
            setIndex((i) => (i + 1) % words.length);
            return;
        }

        const timer = setTimeout(() => {
            setSubIndex((s) => s + (deleting ? -1 : 1));
        }, deleting ? deleteSpeed : typeSpeed);
        return () => clearTimeout(timer);
    }, [subIndex, deleting, index, words, typeSpeed, deleteSpeed, pause]);

    return words.length ? words[index % words.length].substring(0, subIndex) : '';
};

export default useTypewriter;
